import { useDashboardFiltersStore } from "./useDashboardFiltersStore";
import { usePromoterFiltersStore } from "./usePromoterFiltersStore";
import { useProjectFiltersStore } from "./useProjectFiltersStore";
import { useInvestorFiltersStore } from "./useInvestorFiltersStore";
import { useContractFiltersStore } from "./useContractFiltersStore";
import { useNotificationFiltersStore } from "./useNotificationFiltersStore";
import { useInvestmentFiltersStore } from "./useInvestmentFiltersStore";
import { useInvestmentViewModeStore } from "./useInvestmentViewModeStore";
import { useInvestorInvestmentFiltersStore } from "./useInvestorInvestmentFiltersStore";
import { useInvestorDocumentFiltersStore } from "./useInvestorDocumentFiltersStore";
import { useHubProfileStore } from "./useHubProfileStore";

/**
 * Resets all filter and view Zustand stores to their initial state.
 * Used during organization switching to clear stale client-side filter state.
 *
 * When adding or removing a filter store, update this function to keep it in sync.
 */
export const resetAllFilterStores = () => {
	useDashboardFiltersStore.getState().reset();
	usePromoterFiltersStore.getState().reset();
	useProjectFiltersStore.getState().reset();
	useInvestorFiltersStore.getState().reset();
	useContractFiltersStore.getState().reset();
	useNotificationFiltersStore.getState().reset();
	useInvestmentFiltersStore.getState().reset();
	useInvestmentViewModeStore.getState().reset();
	useInvestorInvestmentFiltersStore.getState().reset();
	useInvestorDocumentFiltersStore.getState().reset();
	useHubProfileStore.getState().reset();
};
